import { has } from "lodash";

export const convertObjectToFormData = object => {
  const formData = new FormData();

  for (const key in object) {
    if (has(object, key)) {
      if (Array.isArray(object[key])) {
        object[key].forEach((item, index) => {
          if (typeof item === "object") {
            Object.entries(item).forEach(([subKey, value]) => {
              formData.append(`${key}[${index}][${subKey}]`, value);
            });
          } else {
            formData.append(`${key}[${index}]`, item);
          }
        });
      } else {
        formData.append(key, object[key]);
      }
    }
  }

  return formData;
};
